import React from "react";
import { useLanguage } from "./LanguajeContext";

export default function Topbar() {
  const URL = process.env.REACT_APP_SERVER_URL;
  const translation = {
    es: {
      sign_out: "Cerrar sesión"
    },
    en: {
      sign_out: "Sign out"
    }
  };

  const sign_request = async () => {
    const token = localStorage.get("token");
    
    const res = await fetch(`${URL}/api/operator/session`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: {
        token
      }
    });
  };

  const { language } = useLanguage();
  const t = translation[language];

  return (
    <header className="bg-[#2D4A5E] text-white px-6 py-4 shadow flex justify-between items-center relative z-10">
      <h2 className="text-xl font-semibold">Dashboard Operador</h2>
      <button
        className="bg-red-400 text-black px-4 py-1 rounded hover:bg-red-300 transition"
        onClick={() => {
          localStorage.clear();
          window.location.href = "/";
        }}
      >
        {t.sign_out}
      </button>
    </header>
  );
}